import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/sudokit/components/Dialog";
import { SudoButton } from "src/sudokit/components/SudoButton";

interface DeleteOutlineConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteOutlineConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: DeleteOutlineConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogDescription>
            This will permanently delete your entire outline.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <SudoButton
            variant="tertiaryGrey"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </SudoButton>
          <SudoButton variant="danger" onClick={onConfirm}>
            Yes, I'm sure
          </SudoButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
